/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class GlobalSearchResponseCount {
    'orgs'?: number;
    'jobs'?: number;
    'creatives'?: number;
    'orderLines'?: number;
    'campaigns'?: number;
    'targets'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgs",
            "baseName": "orgs",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "creatives",
            "baseName": "creatives",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "orderLines",
            "baseName": "order_lines",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "campaigns",
            "baseName": "campaigns",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "targets",
            "baseName": "targets",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return GlobalSearchResponseCount.attributeTypeMap;
    }

    public constructor() {
    }
}

